import { render, staticRenderFns } from "./Formulario018PreAnestesico.vue?vue&type=template&id=1e5cd242&scoped=true"
import script from "./Formulario018PreAnestesico.vue?vue&type=script&lang=js"
export * from "./Formulario018PreAnestesico.vue?vue&type=script&lang=js"
import style0 from "./Formulario018PreAnestesico.vue?vue&type=style&index=0&id=1e5cd242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5cd242",
  null
  
)

export default component.exports